<div [ngStyle]="{'display': buttons.display, 'justify-content': buttons.justifyContent, 'align-items': buttons.alignItems, 'flexDirection': buttons.flexDirection}">
  <div *ngFor="let radioButton of buttons.buttons; let i = index">
    <input type="radio" class="radio-button" [name]="name" [value]="radioButton.value"
      [disabled]="radioButton.disabled" [formControl]="control" [id]="'radioButton' + i" />
    <label class="label-radio-button" [for]="'radioButton' + i">{{radioButton.name}}</label>
  </div>
</div>